import React, { useState, useRef, useEffect } from "react";
import Dropdown from "../Dropdown";
import closeIcon from "../../Assets/Icons/close.png";
import Textarea from "../Textaera";
import { ORG_UPDATE_CLIENT_TASK_STATUS } from "../../ApiServices/BaseURL";
import { postData } from "../../ApiServices/ApiService";
import Loader from "../Loader";

const AddCommentModal = ({ isOpen, onClose, isTaskInfo, onSuccess }) => {
  const [comments, setComments] = useState("");
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('')
  //console.log('isTaskInfo:--',isTaskInfo)

  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const resetForm = () => {
    setComments("");
    setTask("");
  };

  const handleClose = () => {
    setComments('');
    setTask('');
    setError('')
    onClose();
};

  const handleAddComment = async () => {

    try {
      setError('');
      setSuccess('');
      if (!task?.value) {
        setError('Comment type is required'); return
      }
      if (!comments) {
        setError('Comments is required'); return
      }
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      // const locationValue = location === 'Online' ? 2 : 1;
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "task_id": isTaskInfo?.task_id,
        "task_status": task?.value,
        "comment_text": comments,
      }
      //console.log('ToDo status payload', payLoad);
      // Make the API call
      const response = await postData(ORG_UPDATE_CLIENT_TASK_STATUS, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setError('')
            // setEmployeeList(responseData?.dataJ || []);
            setSuccess(responseData?.info);
            setTimeout(() => {
              handleClose();
              onSuccess();
              setSuccess('');
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to change status. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to change status.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setError('Unauthorized access. Your session may have expired. Please log in again.');
         
      }
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
        setError(`Failed to change status. Please check your network connection and try again.`);
      
    } finally {
      setLoading(false);
    }
  };

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={() => { handleClose(); }}>
          <img src={closeIcon} alt="Close" style={styles.closeIcon} />
        </button>
        <h2 className="modal-title">Add Comment</h2>
        <hr className="title-divider" />
        <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
          <Dropdown
            ref={(el) => (dropdownRefs.current["taskOptions"] = el)}
            isOpen={openDropdown === "taskOptions"}
            toggleDropdown={() => toggleDropdown("taskOptions")}
            label="Comment Type"
            options={[
              { "value": 12, "label": "Task Issue" },
              { "value": 13, "label": "Hold Task" }
            ]}
            value={task}
            onChange={setTask}
          />
          <div style={{ ...styles.actionField }}>
         <Textarea
              label="Comments"
              placeholder="Enter your comments here..."
              value={comments}
              onChange={(e) => { setComments(e.target.value) }}
              // errorMessage={errorMessage}
              maxLength={200}
              width={null}
            />
          </div>
        </div>
        <hr className="footer-divider" />
        {error && <div className="list-error-msg" style={{ padding: 0 }}> {error}</div>}
        {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}
        <div className="button-container">
          <button className="add-client-button" onClick={handleAddComment} style={{ opacity: loading ? 0.5 : 1 }} disabled={loading}> {loading &&
            <span style={{ paddingRight: 5 }} ><Loader loading={loading} color={'var(--background-color)'} size="small" /> </span>
          } Add Comment</button>
          <button className="cancel-button" onClick={() => { handleClose(); }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  closeIcon: {
    width: "16px",
    height: "16px",
  },
  actionField: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    marginBottom: "8px",
    color: "#343C44",
  },
  textarea: {
    padding: "10px",
    border: "1px solid #D6E4EC",
    borderRadius: "5px",
    resize: "none",
    height: "87px",
    fontSize: "14px",
    color: "#333",
    width: '575px'
  },
};

export default AddCommentModal;
